import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function useDefaultCurrency() {
  const [currency, setCurrency] = useState("");
  const { currentBusiness } = useSelector((state) => state.auth);

  useEffect(() => {
    if (currentBusiness) {
      const { fiat_wallet_details } = currentBusiness;
      const defaultWalletCurrency = fiat_wallet_details?.find(
        (item) => item.wallet_type?.toLowerCase() === "default"
      )?.currency;
      setCurrency(defaultWalletCurrency);
    }
  }, [currentBusiness]);
  return {
    currency,
  };
}
